import React from 'react';
import { Clock, Timer } from 'lucide-react';
import { differenceInHours, differenceInDays, addDays } from 'date-fns';

interface AutoCloseIndicatorProps {
  status: string;
  dataResolucao: string | null;
  autoCloseDays?: number;
}

export const AutoCloseIndicator: React.FC<AutoCloseIndicatorProps> = ({
  status,
  dataResolucao,
  autoCloseDays = 3,
}) => {
  if (status !== 'resolvida' || !dataResolucao) return null;

  const resolvedDate = new Date(dataResolucao);
  const autoCloseDate = addDays(resolvedDate, autoCloseDays);
  const now = new Date();

  if (autoCloseDate <= now) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-destructive bg-destructive/10 rounded-md px-2 py-1">
        <Timer className="h-3 w-3" />
        <span>Fechamento automático em breve</span>
      </div>
    );
  }

  const hoursLeft = differenceInHours(autoCloseDate, now);
  const daysLeft = differenceInDays(autoCloseDate, now);

  let timeText: string;
  if (daysLeft >= 1) {
    const remainingHours = hoursLeft - daysLeft * 24;
    timeText = remainingHours > 0
      ? `${daysLeft}d ${remainingHours}h`
      : `${daysLeft}d`;
  } else {
    timeText = `${hoursLeft}h`;
  }

  return (
    <div className="flex items-center gap-1.5 text-xs text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/30 rounded-md px-2 py-1">
      <Clock className="h-3 w-3" />
      <span>Fecha automaticamente em {timeText}</span>
    </div>
  );
};
